import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../../basic-ui-components/icon/svg-icon/svg.icon';

export class BlogIcon extends React.Component<ISvgIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M2,19.755c0-0.276,0.224-0.5,0.5-0.5h19
                        c0.276,0,0.5,0.224,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5h-19C2.224,20.255,2,20.031,2,19.755z"/>
                    <path d="M2,16.128c0-0.276,0.224-0.5,0.5-0.5h5.113
                        c0.276,0,0.5,0.224,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5H2.5C2.224,16.628,2,16.404,2,16.128z"/>
                    <path d="M15.887,16.128c0-0.276,0.224-0.5,0.5-0.5H21.5
                        c0.276,0,0.5,0.224,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5h-5.113C16.111,16.628,15.887,16.404,15.887,16.128z"/>
                    <path d="M2,12.577c0-0.276,0.224-0.5,0.5-0.5h5.113
                        c0.276,0,0.5,0.224,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5H2.5C2.224,13.077,2,12.853,2,12.577z"/>
                    <path d="M18.707,12.577c0-0.276,0.224-0.5,0.5-0.5h2.102
                        c0.276,0,0.5,0.224,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5h-2.102C18.931,13.077,18.707,12.853,18.707,12.577z"/>
                    <path d="M16.121,4.501c0.542-0.797,1.632-0.996,2.421-0.442
                        c0.756,0.532,0.96,1.565,0.462,2.343l-5.268,8.235c-0.041,0.065-0.097,0.119-0.162,0.16l-2.469,1.528
                        c-0.508,0.314-1.151-0.112-1.06-0.702l0.42-2.717c0.012-0.075,0.04-0.147,0.083-0.21L16.121,4.501z M17.967,4.877
                        c-0.332-0.233-0.791-0.15-1.019,0.186l-5.512,8.104l-0.304,1.964l1.821-1.126l5.209-8.142C18.371,5.536,18.285,5.101,17.967,4.877z"
                        />
                </g>
            </SvgIcon>
        );
    }
}
